import { AnyAction } from "redux";
import _ from "lodash";

import { isFailure, ProfilesServiceErrorCode, Protection } from "@sportal/api";
import {
  saveCustomProtection,
  wipeCustomProtection,
} from "../../pages/profiles/components/webFilters/webFilters.actions";
import { dehydrate, rehydrate } from "./profiles.helpers";
import { saveSchedules } from "../../pages/profiles/components/schedule/schedules.actions";
import { saveSsProfiles } from "../../pages/profiles/components/internetSecurity/subscriberSafety/ssProfiles.actions";
import { getValidationErrors } from "../../pages/profiles/components/schedule/schedules.selectors";
import { SBThunkAction } from "../redux.types";
import { createProfilesSuccess } from "./profiles.actions";
import { SBProfile } from "./profiles.types";
import { getSubscriberId } from "../info/info.selectors";
import { getSchedules } from "../root.selectors";

// TODO: amitrofa: probably should not be a thunk, think a little bit more
//  also it is creation in terms of BE
export const createProfilesRequest =
  (profiles: SBProfile[]): SBThunkAction<Promise<SBProfile[]>, AnyAction> =>
  async (dispatch, getState, { api }) => {
    const state = getState();
    const subscriberId = getSubscriberId(state);
    const schedules = getSchedules(state);

    const errors = getValidationErrors(schedules);
    if (!_.isEmpty(errors)) {
      return Promise.reject({ customErrors: errors });
    }

    const result = await api.ssm.profiles.create(
      subscriberId,
      // @ts-ignore
      _.map(profiles, dehydrate)
    );

    if (isFailure(result)) {
      const { code } = result.error;
      let errors = [];

      if (code === ProfilesServiceErrorCode.LIMIT_REACHED) {
        errors.push({ message: "profile_limit_reached_wizard" });
      }

      return Promise.reject({ customErrors: errors, error: result.error });
    }

    const { data } = result;

    const updateMap = _.reduce(
      profiles,
      (map, profile) => ({
        ...map,
        [profile.id]: data.find(({ name }) => name === profile.name).id,
      }),
      {}
    );

    dispatch(updateProfileIds(updateMap));

    await _.reduce(
      data,
      (result, profile) => {
        if (profile.protection === Protection.Custom) {
          return result.then(() => dispatch(saveCustomProtection(profile)));
        } else {
          dispatch(wipeCustomProtection(profile.id));
          return result;
        }
      },
      Promise.resolve()
    );

    const savedProfiles = _.map(data, (profile) => rehydrate(profile, state));

    await dispatch(saveSchedules());
    dispatch(createProfilesSuccess(savedProfiles));
    await dispatch(saveSsProfiles(savedProfiles));

    return Promise.resolve(savedProfiles);
  };

export const UPDATE_PROFILE_IDS = "[PROFILES] UPDATE_PROFILE_IDS";
export const updateProfileIds = (map) => {
  return {
    type: UPDATE_PROFILE_IDS,
    payload: { map },
  };
};
